/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SiloGovernorV2,
  SiloGovernorV2Interface,
} from "../SiloGovernorV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ERC20Votes",
        name: "_token",
        type: "address",
      },
      {
        internalType: "contract TimelockController",
        name: "_timelock",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_initialVotingDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialVotingPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialProposalThreshold",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "proposer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "signatures",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "eta",
        type: "uint256",
      },
    ],
    name: "ProposalQueued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldProposalThreshold",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "ProposalThresholdSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldQuorumNumerator",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "QuorumNumeratorUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldTimelock",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newTimelock",
        type: "address",
      },
    ],
    name: "TimelockChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "weight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "VoteCast",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingDelay",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "VotingDelaySet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingPeriod",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "VotingPeriodSet",
    type: "event",
  },
  {
    inputs: [],
    name: "BALLOT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "COUNTING_MODE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
    ],
    name: "castVote",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "castVoteBySig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "castVoteWithReason",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockNumber",
        type: "uint256",
      },
    ],
    name: "getVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasVoted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "hashProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalDeadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalEta",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "againstVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "forVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "abstainVotes",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "_calldatas",
        type: "bytes[]",
      },
      {
        internalType: "string",
        name: "_description",
        type: "string",
      },
    ],
    name: "propose",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "queue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_blockNumber",
        type: "uint256",
      },
    ],
    name: "quorum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumDenominator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumNumerator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "setProposalThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "setVotingDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "setVotingPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "state",
    outputs: [
      {
        internalType: "enum IGovernor.ProposalState",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "_interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timelock",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract ERC20Votes",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "updateQuorumNumerator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract TimelockController",
        name: "newTimelock",
        type: "address",
      },
    ],
    name: "updateTimelock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type SiloGovernorV2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloGovernorV2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloGovernorV2__factory extends ContractFactory {
  constructor(...args: SiloGovernorV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloGovernorV2";
  }

  deploy(
    _token: string,
    _timelock: string,
    _initialVotingDelay: BigNumberish,
    _initialVotingPeriod: BigNumberish,
    _initialProposalThreshold: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloGovernorV2> {
    return super.deploy(
      _token,
      _timelock,
      _initialVotingDelay,
      _initialVotingPeriod,
      _initialProposalThreshold,
      overrides || {}
    ) as Promise<SiloGovernorV2>;
  }
  getDeployTransaction(
    _token: string,
    _timelock: string,
    _initialVotingDelay: BigNumberish,
    _initialVotingPeriod: BigNumberish,
    _initialProposalThreshold: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _token,
      _timelock,
      _initialVotingDelay,
      _initialVotingPeriod,
      _initialProposalThreshold,
      overrides || {}
    );
  }
  attach(address: string): SiloGovernorV2 {
    return super.attach(address) as SiloGovernorV2;
  }
  connect(signer: Signer): SiloGovernorV2__factory {
    return super.connect(signer) as SiloGovernorV2__factory;
  }
  static readonly contractName: "SiloGovernorV2";
  public readonly contractName: "SiloGovernorV2";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloGovernorV2Interface {
    return new utils.Interface(_abi) as SiloGovernorV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloGovernorV2 {
    return new Contract(address, _abi, signerOrProvider) as SiloGovernorV2;
  }
}
